import React from "react"
import Layout from "../layout/Layout"
import SEO from "../components/seo/seo"
import styled from "styled-components"
import PageHeader from "../components/pageHeader/PageHeader"
import AboutTop from "../pagesParts/about/AboutTop"
import AboutMid from "../pagesParts/about/AboutMid"
import AboutBot from "../pagesParts/about/AboutBot"

const StyledMainDiv = styled.main`
  margin-top: 120px;
`

export default function AboutPage() {
  return (
    <Layout>
      <SEO
        title="About Us"
        description="Origin Restaurant is a new and well-known restaurant in Ethiopia, serving flavorful chaofan, juicy steak sandwiches, classic hotdogs, crispy fries, and ice-cold drinks."
      />
      <StyledMainDiv>
        <PageHeader
          heading="About Us"
          subheading="Origin Restaurant is based in Ethiopia and built around bold flavor — chaofan, steak sandwiches, hotdogs, crispy fries, and ice-cold drinks."
        />
        <AboutTop />
        <AboutMid />
        <AboutBot />
      </StyledMainDiv>
    </Layout>
  )
}
